import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

import { HttpService } from '../core/http.service';
import { GlobalsService } from '../globals.service';

import {
  TtdPartner,
} from '../../models/services/admin/ttd';

@Injectable({
  providedIn: 'root'
})
export class AdminTTDService {

  constructor(
    private httpService: HttpService,
    private globalsService: GlobalsService
  ) {}

  public getTtdPartner(): Observable<TtdPartner[]> {
    const url = `${environment.adminServicesApiBaseUri}/ttd/partners`;
    return this.httpService.get(url, this.globalsService.getActiveCompany()?.id);
  }

  public updateTtdPartners(partners: TtdPartner[]): Observable<void> {
    const url = `${environment.adminServicesApiBaseUri}/ttd/partners`;
    return this.httpService.putNoResponse(url, partners, this.globalsService.getActiveCompany()?.id, true);
  }
}
